import { ReactElement } from 'react';

import { useUsersCompanyListQuery } from 'api';
import { CompanySelect } from 'components';
import { SelectOption } from 'types';

import { useCompanySwitchMutation } from './hooks';
import { Wrapper } from './styled';

export function CompanySelector(): ReactElement {
  const byPassSub = true;
  const { companyList = [], currentCompany } = useUsersCompanyListQuery(byPassSub);

  let selectedCompany: SelectOption = { value: '', label: '' };
  if (currentCompany?.id && companyList.length) {
    selectedCompany = companyList?.find(
      (company: SelectOption) => company.value === currentCompany.id,
    ) || { value: '', label: '' };
  }

  const { switchCompanyUserMutation } = useCompanySwitchMutation({ reload: true });

  const handleCompanyChange = async (selectedCompanyId: string) => {
    await switchCompanyUserMutation({ selectedCompanyId, byPassSub });
  };

  return (
    <Wrapper>
      {companyList?.length && selectedCompany.label ? (
        <CompanySelect
          key="company"
          id="id"
          options={companyList}
          selectedCompany={selectedCompany}
          name="company"
          onChange={handleCompanyChange}
        />
      ) : (
        <></>
      )}
    </Wrapper>
  );
}
